<div mat-dialog-title class="description">{{data.title}}</div>
<div mat-dialog-content class="desc-content">
    <p>{{data.msg}}</p>
</div>
<div mat-dialog-actions class="actions">
    <button mat-button class="geaui-button-secondary actionbutton" (click)="dialogRef.close(false)">No</button>
    <button mat-button class="geaui-button-primary actionbutton" (click)="dialogRef.close(true)" cdkFocusInitial>Yes</button>
</div>